import { render, staticRenderFns } from "./bottom-products.vue?vue&type=template&id=69e3f593&scoped=true&"
import script from "./bottom-products.vue?vue&type=script&lang=js&"
export * from "./bottom-products.vue?vue&type=script&lang=js&"
import style0 from "./bottom-products.vue?vue&type=style&index=0&id=69e3f593&lang=scss&scoped=true&"
import style1 from "./bottom-products.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e3f593",
  null
  
)

export default component.exports